import React from 'react';
import { Box } from '@mui/material';
import styles from './OvelContainerWrapper.module.css';

function OvelContainerWrapper({ children }) {
  return <Box className={styles.wrapper}>{children}</Box>;
}

export default OvelContainerWrapper;
